import router from "@/router";
import config from "@/config/brands/index";
import * as MUTATIONS from "./mutation-types";
import { circuitos } from "@/config/constants/index";

export const caminosBiometria = {
  ERROR: (context, getResult, callback) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_BIOMETRIA_POSITIVO, { isValid: false });
    context.commit(MUTATIONS.ON_FUNNEL_ERROR, getResult.data);
    context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-reintentos-biometria");
    return callback();
  },
  errorCA: (context, callback) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_BIOMETRIA_POSITIVO, { isValid: false });
    context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-veridas-ca");
    return callback();
  },
  biometriaOk: (context, callback) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_BIOMETRIA_POSITIVO, { isValid: true });
    router.replace(
      config.pasos[config.pasos.loadingVeridas.pasoSiguiente].path
    );
    return callback();
  },
  pperless: (context, callback) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_BIOMETRIA_POSITIVO, { isValid: false });
    context.commit(MUTATIONS.ON_ERROR_VERIDAS, "error-reintentos-biometria");
    return callback();
  },
  reintentoOk: (context, callback) => {
    context.commit(MUTATIONS.ON_IS_LOADING, false);
    context.commit(MUTATIONS.ON_BIOMETRIA_POSITIVO, { isValid: false });
    context.commit(MUTATIONS.ON_ERROR_VERIDAS, "no-identificado-veridas");
    return callback();
  }
};

export const setearCaminosBiometria = (
  isValid,
  puedeReintentar,
  circuito = null
) => {
  const { CA_SUELTA, CA_NOMINA, CA_EMPRENDEDORES, CGU } = circuitos;
  const circuitosCA = [CA_SUELTA, CA_NOMINA, CA_EMPRENDEDORES, CGU];
  if (isValid) return "biometriaOk";
  if (puedeReintentar === false && circuitosCA.includes(circuito))
    return "errorCA";
  return puedeReintentar ? "reintentoOk" : "pperless";
};
